// cpfPaciente,  
// nomePaciente,
// sexoPaciente,
// dataNascimentoPaciente,
// emailPaciente, 
// dddCelularPaciente,
// numeroCelularPaciente, 

import { isValid, parse } from 'date-fns'

import { object, string, date } from 'yup'

const parseDateString = (value, originalValue) => {
    if (typeof originalValue === "string") {
        const parsedDate = parse(originalValue, "dd/MM/yyyy", new Date())
        return isValid(parsedDate) ? parsedDate : new Date("") 
    }
    return originalValue
}

export const schema = object({
    cpfPaciente: string()
        .required("O campo é requerido e não pode ficar vazio"),
    nomePaciente: string()
        .min(10, 'O campo deve conter mais de 10 caracteres')
        .required("O campo é requerido e não pode ficar vazio"),
    sexoPaciente: string()
        .oneOf(['M', 'F'], "Selecione uma opção")
        .required("O campo é requerido e não pode ficar vazio"),
    dataNascimento: date()
        .transform(parseDateString)
        .required("O campo é obrigatório e não pode ficar vazio")
        .typeError("Digite uma data válida no formato dd/MM/yyyy")
        .min(new Date(1800, 0, 1), "Digite uma data válida") // Mês é indexado a partir do 0
        .max(new Date(), "Digite uma data de nascimento válida"),
    emailPaciente: string()
        .email("Digite um email válido")
        .required("O campo é requerido e não pode ficar vazio"),
    dddCelularPaciente: string()
        .min(2, 'Preencha')
        .required("Preencha"),
    numeroCelularPaciente: string()
        .min(8, "O total de caracteres não pode ser menor que 8")
        .required("O campo é requerido e não pode ficar vazio")
    
})
